/**
 * Reluxe Global Auth
 * Lightweight auth & header components for all pages
 * Include this in theme.liquid before </body>
 */

(function() {
  'use strict';

  const API_BASE = 'https://api.thereluxe.com';

  // Auth state
  let reluxeUserId = null;
  let authChecked = false;

  // Check if user is logged in via Reluxe auth
  async function checkReluxeAuth() {
    if (authChecked) return reluxeUserId;
    authChecked = true;

    try {
      const response = await fetch(`${API_BASE}/api/auth/me`, {
        method: 'GET',
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.user && data.user.id) {
          reluxeUserId = `reluxe_${data.user.id}`;
          // auth confirmed
          return reluxeUserId;
        }
      }
    } catch (e) {
      // auth check failed silently
    }

    return null;
  }

  function getCustomerId() {
    if (reluxeUserId) return reluxeUserId;
    if (window.ReluxeCustomerId) return window.ReluxeCustomerId;
    if (window.__st && window.__st.cid) return window.__st.cid;
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
      return window.ShopifyAnalytics.meta.page.customerId;
    }
    return null;
  }

  function isCustomerLoggedIn() {
    return !!getCustomerId();
  }

  // Show magic link sign-in modal
  function showSignInModal() {
    localStorage.setItem('reluxe_return_url', window.location.pathname + window.location.search);

    const modal = document.createElement('div');
    modal.className = 'reluxe-signin-modal';
    modal.innerHTML = `
      <div class="reluxe-signin-modal__backdrop" onclick="ReluxeAuth.closeSignInModal()"></div>
      <div class="reluxe-signin-modal__content">
        <button class="reluxe-signin-modal__close" onclick="ReluxeAuth.closeSignInModal()">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
        <div class="reluxe-signin-modal__icon">
          <svg viewBox="0 0 24 24" width="48" height="48">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        </div>
        <h3>Save Your Favorites</h3>
        <p>Enter your email to sign in or create an account. We'll send you a secure link.</p>
        <form class="reluxe-signin-modal__form" onsubmit="ReluxeAuth.submitMagicLink(event)">
          <input type="email"
                 class="reluxe-signin-modal__input"
                 placeholder="Enter your email"
                 required
                 autocomplete="email"
                 id="reluxe-signin-email">
          <button type="submit" class="reluxe-signin-modal__btn reluxe-signin-modal__btn--primary">
            <span class="reluxe-signin-modal__btn-text">Continue</span>
            <span class="reluxe-signin-modal__btn-loading" style="display:none;">Sending...</span>
          </button>
        </form>
        <p class="reluxe-signin-modal__hint">No password needed - we'll email you a sign-in link</p>
        <div class="reluxe-signin-modal__success" style="display:none;">
          <svg viewBox="0 0 24 24" width="32" height="32" fill="#22c55e">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
          <p>Check your email! We sent you a sign-in link.</p>
        </div>
        <div class="reluxe-signin-modal__error" style="display:none;"></div>
      </div>
    `;
    document.body.appendChild(modal);
    document.body.classList.add('reluxe-modal-open');

    setTimeout(() => {
      const input = document.getElementById('reluxe-signin-email');
      if (input) input.focus();
    }, 100);

    document.addEventListener('keydown', handleEscKey);
  }

  async function submitMagicLink(event) {
    event.preventDefault();

    const form = event.target;
    const emailInput = document.getElementById('reluxe-signin-email');
    const btnText = form.querySelector('.reluxe-signin-modal__btn-text');
    const btnLoading = form.querySelector('.reluxe-signin-modal__btn-loading');
    const successEl = document.querySelector('.reluxe-signin-modal__success');
    const errorEl = document.querySelector('.reluxe-signin-modal__error');
    const submitBtn = form.querySelector('button[type="submit"]');

    const email = emailInput.value.trim();
    if (!email) return;

    btnText.style.display = 'none';
    btnLoading.style.display = 'inline';
    submitBtn.disabled = true;
    errorEl.style.display = 'none';

    try {
      const returnUrl = localStorage.getItem('reluxe_return_url') || window.location.pathname;

      const response = await fetch(`${API_BASE}/api/auth/request-magic-link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, return_url: returnUrl }),
        credentials: 'include'
      });

      const data = await response.json();

      if (data.success) {
        form.style.display = 'none';
        document.querySelector('.reluxe-signin-modal__hint').style.display = 'none';
        successEl.style.display = 'block';
      } else {
        errorEl.textContent = data.error || 'Something went wrong. Please try again.';
        errorEl.style.display = 'block';
        btnText.style.display = 'inline';
        btnLoading.style.display = 'none';
        submitBtn.disabled = false;
      }
    } catch (e) {
      console.error('[ReluxeAuth] Magic link error:', e);
      errorEl.textContent = 'Connection error. Please try again.';
      errorEl.style.display = 'block';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
      submitBtn.disabled = false;
    }
  }

  function handleEscKey(e) {
    if (e.key === 'Escape') {
      closeSignInModal();
    }
  }

  function closeSignInModal() {
    const modal = document.querySelector('.reluxe-signin-modal');
    if (modal) {
      modal.remove();
      document.body.classList.remove('reluxe-modal-open');
      document.removeEventListener('keydown', handleEscKey);
    }
  }

  async function signOut() {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } finally {
      reluxeUserId = null;
      authChecked = false;
      window.location.reload();
    }
  }

  // Initialize header heart icon
  function initHeaderHeart() {
    const headerSelectors = [
      '.header__icons',
      '.header-icons',
      '.site-header__icons',
      '.header__icon-list',
      '[data-header-icons]',
      '.header-actions',
      '.header__actions'
    ];

    let headerIcons = null;
    for (const selector of headerSelectors) {
      headerIcons = document.querySelector(selector);
      if (headerIcons) break;
    }

    if (!headerIcons) {
      const cartIcon = document.querySelector('[href*="/cart"], .cart-icon, .header__cart');
      if (cartIcon && cartIcon.parentElement) {
        headerIcons = cartIcon.parentElement;
      }
    }

    if (!headerIcons) return;
    if (document.querySelector('.reluxe-header-heart')) return;

    const heartLink = document.createElement('a');
    heartLink.href = '/pages/favorites';
    heartLink.className = 'reluxe-header-heart';
    heartLink.setAttribute('aria-label', 'My Favorites');
    heartLink.innerHTML = `
      <svg viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
      <span class="reluxe-header-heart__badge"></span>
    `;

    const cartLink = headerIcons.querySelector('[href*="/cart"], .cart-icon, .header__cart, [data-cart-icon]');
    if (cartLink) {
      cartLink.parentNode.insertBefore(heartLink, cartLink);
    } else {
      headerIcons.appendChild(heartLink);
    }

    updateHeaderHeartBadge();
  }

  async function updateHeaderHeartBadge() {
    const badge = document.querySelector('.reluxe-header-heart__badge');
    if (!badge) return;

    const customerId = getCustomerId();
    if (!customerId) {
      badge.style.display = 'none';
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/api/customer/${customerId}/favorites`, { credentials: 'include' });
      if (!response.ok) {
        badge.style.display = 'none';
        return;
      }
      const data = await response.json();
      const count = data.favorites ? data.favorites.length : 0;

      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    } catch (e) {
      badge.style.display = 'none';
    }
  }

  // Initialize account link in header (Sign In / Sign Out)
  function initHeaderAccount() {
    // Hide default Shopify account icon
    const shopifyAccountSelectors = [
      '[href*="/account"]',
      '.header__icon--account',
      '.site-header__account',
      '[data-account-icon]',
      '.account-link',
      '.icon-account'
    ];

    for (const selector of shopifyAccountSelectors) {
      const accountIcon = document.querySelector(selector);
      if (accountIcon && !accountIcon.classList.contains('reluxe-header-account')) {
        accountIcon.style.display = 'none';
      }
    }

    if (document.querySelector('.reluxe-header-account')) return;

    const headerSelectors = [
      '.header__icons',
      '.header-icons',
      '.site-header__icons',
      '.header__icon-list',
      '[data-header-icons]',
      '.header-actions',
      '.header__actions'
    ];

    let headerIcons = null;
    for (const selector of headerSelectors) {
      headerIcons = document.querySelector(selector);
      if (headerIcons) break;
    }

    if (!headerIcons) {
      const cartIcon = document.querySelector('[href*="/cart"], .cart-icon, .header__cart');
      if (cartIcon && cartIcon.parentElement) {
        headerIcons = cartIcon.parentElement;
      }
    }

    if (!headerIcons) return;

    const accountLink = document.createElement('a');
    accountLink.className = 'reluxe-header-account';
    accountLink.href = '#';

    if (reluxeUserId) {
      accountLink.textContent = 'Sign Out';
      accountLink.onclick = function(e) {
        e.preventDefault();
        signOut();
      };
    } else {
      accountLink.textContent = 'Sign In';
      accountLink.onclick = function(e) {
        e.preventDefault();
        showSignInModal();
      };
    }

    const heartIcon = headerIcons.querySelector('.reluxe-header-heart');
    if (heartIcon) {
      heartIcon.parentNode.insertBefore(accountLink, heartIcon);
    } else {
      headerIcons.insertBefore(accountLink, headerIcons.firstChild);
    }
  }

  /**
   * Track product page view for analytics
   * Sends view event to API for popularity scoring
   */
  function trackProductView() {
    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;

    // Extract product handle from URL
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex === -1 || productsIndex + 1 >= pathParts.length) return;

    const handle = pathParts[productsIndex + 1].split('?')[0];
    if (!handle) return;

    // Deduplicate: only count once per session per product
    const viewedKey = `reluxe_viewed_${handle}`;
    if (sessionStorage.getItem(viewedKey)) return;
    sessionStorage.setItem(viewedKey, '1');

    // Get or create session ID for anonymous tracking
    let sessionId = sessionStorage.getItem('reluxe_session_id');
    if (!sessionId) {
      const arr = new Uint32Array(2);
      crypto.getRandomValues(arr);
      sessionId = 'sess_' + arr[0].toString(36) + arr[1].toString(36);
      sessionStorage.setItem('reluxe_session_id', sessionId);
    }

    // Get customer ID if logged in
    const customerId = getCustomerId();

    // Get search query from referrer if came from search
    let searchQuery = '';
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('ref_q')) {
      searchQuery = urlParams.get('ref_q');
    } else if (document.referrer.includes('/search') || document.referrer.includes('q=')) {
      try {
        const refUrl = new URL(document.referrer);
        searchQuery = refUrl.searchParams.get('q') || '';
      } catch (e) {}
    }

    // Send view event to API
    fetch(`${API_BASE}/api/product/${encodeURIComponent(handle)}/view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: customerId,
        session_id: sessionId,
        referrer: document.referrer,
        search_query: searchQuery
      }),
      credentials: 'include'
    }).catch(e => {
      // Silently fail - analytics shouldn't break the page
      console.log('[ReluxeAuth] View tracking failed:', e);
    });
  }

  // Main initialization
  async function initAll() {
    await checkReluxeAuth();
    initHeaderHeart();
    initHeaderAccount();
    trackProductView();
  }

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Expose global API
  window.ReluxeAuth = {
    showSignInModal,
    closeSignInModal,
    submitMagicLink,
    signOut,
    isLoggedIn: isCustomerLoggedIn,
    getCustomerId,
    updateHeaderHeartBadge
  };

})();
